// extracted by mini-css-extract-plugin
module.exports = {"color1":"#a1cac8","color2":"#fff","color3":"#f5f5f5","color4":"#000","borderThickness":"5px","App":"App_App__2mBMi"};